export default class Toggle {
	/**
	 * Toggle object which uses the aria-pressed attribute.
	 *
	 * @param element {HTMLElement}
	 * @param callback {function}
	 */
	constructor(element, callback) {
		this.ATTRIBUTE = 'aria-pressed';
		this.element = element;
		this.state = this.pressed();
		this.callback = callback;

		this.element.addEventListener('click', (event) => {
			event.preventDefault();
			this.toggle();

			if (typeof this.callback === 'function')
				this.callback(event);
		});
	}

	/**
	 * Returns and optionally sets the pressed state.
	 *
	 * @param bool {null|string}
	 * @returns {string}
	 */
	pressed(bool = null) {
		let pressed = this.element.getAttribute(this.ATTRIBUTE) ?? 'false';

		if (bool === null)
			return pressed;

		const newPressed = String(bool);
		this.element.setAttribute(this.ATTRIBUTE, newPressed);
		return newPressed;
	}

	/**
	 * Toggle the pressed state.
	 */
	toggle() {
		if (this.state === 'false')
			this.state = this.pressed('true');
		else
			this.state = this.pressed('false');
	}
}
